
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class InstanceDialog extends Serenity.EntityDialog<InstanceRow, any> {
        protected getFormKey() { return InstanceForm.formKey; }
        protected getIdProperty() { return InstanceRow.idProperty; }
        protected getLocalTextPrefix() { return InstanceRow.localTextPrefix; }
        protected getNameProperty() { return InstanceRow.nameProperty; }
        protected getService() { return InstanceService.baseUrl; }

        protected form = new InstanceForm(this.idPrefix);

    }
}